
(function () {
  const selector = 'a[data-mobile-image-toggle]';
  let activeCard = null;

  document.addEventListener('click', function (event) {
    if (window.innerWidth > 767) {
  return;
}

    const link = event.target.closest(selector);

    if (!link) {
      if (activeCard) {
        activeCard.classList.remove('mobile-image-active');
        activeCard = null;
      }
      return;
    }

    const card = link.closest('.grid-product');
    const secondImage = card.querySelector('.grid-product__secondary-image');

    if (!card || !secondImage) return;

    if (activeCard !== card) {
  event.preventDefault();
  event.stopImmediatePropagation();
      if (activeCard) {
        activeCard.classList.remove('mobile-image-active');
      }

      card.classList.add('mobile-image-active');
      activeCard = card;
    }
  }, true);
})();
